export enum SubscriptionStatus {
    Active = "Active",
    BeingCancelled = "BeingCancelled",
    Cancelled = "Cancelled",
}